import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from '../Service/gurd-service.service';
import { OtherService } from '../Service/other.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import axios from 'src/app/Service/axios';
declare let $: any

@Component({

  selector: 'app-manage-driver-performance',

  templateUrl: './manage-driver-performance.component.html',

  styleUrls: ['./manage-driver-performance.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ManageDriverPerformanceComponent implements OnInit {

  list_Drivers: any = [];

  list_Result: any = [];

  lst_Search: any = [];

  total_iSalary: number = 0;

  total_iSalaryTemp: number = 0;

  total_iSalaryFloat: number = 0;

  total_iSalaryMission: number = 0;

  total_iSalaryTotal: number = 0;

  total_tiTripCount: number = 0;

  lst_Headers = [
    { strName: '#' },
    { strName: 'انتخاب', checkbox: true },
    { strName: 'عملیات' },
    { strName: 'وضعیت' },
    { strName: 'تاریخ' },
    { strName: 'روز' },
    { strName: 'تعطیل' },
    { strName: 'حقوق' },
    { strName: 'اضافه کاری' },
    { strName: 'پاداش شناور' },
    { strName: 'ماموریت' },
    { strName: 'جمع حقوق' },
    { strName: 'ساعت شروع' },
    { strName: 'ساعت شروع ویرایش شده' },
    { strName: 'ساعت پایان' },
    { strName: 'ساعت پایان ویرایش شده' },
    { strName: 'مدت حضور' },
    { strName: 'مدت حرکت' },
    { strName: 'مدت اضافه کاری' },
    { strName: 'ماموریتی' },
    { strName: 'ماموریت ویرایش شده' },
    { strName: 'شهری' },
    { strName: 'شهری ویرایش شده' },
    { strName: 'کل' },
    { strName: 'تعداد سفر' },
    { strName: 'سفر ویرایش شده' },
    { strName: 'سفر شناور' },
    { strName: 'سفر تشویقی' },
  ];

  lst_HeadersPrint = [
    { strName: '#' },
    { strName: 'تاریخ' },
    { strName: 'روز' },
    { strName: 'شروع' },
    { strName: 'پایان' },
    { strName: 'شهری(km)' },
    { strName: 'ماموریتی(km)' },
    { strName: 'سفر' },
    { strName: 'حقوق' },
    { strName: 'اضافه کاری' },
    { strName: 'شناوری' },
    { strName: 'ماموریت ' },
  ];

  lstiAttendanceDriver = []

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strUnitID: new FormControl('', Validators.required),

    strPersonnelID: new FormControl(''),

    strFullName: new FormControl(''),

    strMobileDomain: new FormControl(''),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  })

  mdl_Edit: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iAttendanceDriver: new FormControl('', Validators.required),

    strStartTime_: new FormControl('', Validators.required),

    strEndTime_: new FormControl('', Validators.required),

    tiTripCount_: new FormControl('', Validators.required),

    fKm_: new FormControl('', Validators.required),

    fKmMission_: new FormControl('', Validators.required),

    tiEncourageTrip: new FormControl('', Validators.required),

    index: new FormControl(''),

  })

  mdl_FullEdit: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strUnitID: new FormControl('', Validators.required),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    bStartTime: new FormControl(false),

    strStartTime_: new FormControl(''),

    bEndTime: new FormControl(false),

    strEndTime_: new FormControl(''),

  })

  mdl_Transfer: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strUnitID: new FormControl('', Validators.required),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    lstiAttendanceDriver: new FormControl(''),

    bStartTime: new FormControl(false),

    bEndTime: new FormControl(false),

    bfKm: new FormControl(false),

    bfkmMission: new FormControl(''),

    bTitripCount: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.getDrivers();

  }

  async getDrivers() {

    this._otherService.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`Peysepar_Mobile_List`, model)).data.toString())

    this._otherService.nonespinner()

    this.list_Drivers = res;

  }

  filter_list(val: any) {

    this.list_Result = this.lst_Search.filter((el: any) => {

      return el.strDayName.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Result = this.lst_Search;

    }

    this.calculateTotals();

  }

  async getResult() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید.')

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`AttendanceDriver2_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwZ' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_Result = res;

    this.lst_Search = res;

    this.calculateTotals();

  }

  selectedDriver(item: any) {

    if (item?.strUnitID) {

      this.mdl_Search.patchValue({

        strUnitID: item?.strUnitID,

        strFullName: item?.strFullName,

        strMobileDomain: item?.strMobileDomain_strComment,

        strPersonnelID: item?.strPersonnelID,

      })

    }

    else {

      this.mdl_Search.patchValue({

        strUnitID: '',

        strFullName: '',

        strMobileDomain_strComment: '',

        strPersonnelID: '',

      })

    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  calculateTotals() {
    this.total_iSalary = 0;
    this.total_iSalaryTemp = 0;
    this.total_iSalaryFloat = 0;
    this.total_iSalaryMission = 0;
    this.total_iSalaryTotal = 0;
    this.total_tiTripCount = 0;

    for (const item of this.list_Result) {
      this.total_iSalary += parseFloat(item.iSalary || 0);
      this.total_iSalaryTemp += parseFloat(item.iSalaryTemp || 0);
      this.total_iSalaryFloat += parseFloat(item.iSalaryFloat || 0);
      this.total_iSalaryMission += parseFloat(item.iSalaryMission || 0);
      this.total_iSalaryTotal += parseFloat(item.iSalaryTotal || 0);
      this.total_tiTripCount += parseInt(item.tiTripCount || 0, 10);
    }

  }

  open_Edit(item, index: number) {

    if (item.tiStatus < 2) {

      Object.keys(item).forEach((key) => {

        this.mdl_Edit.get(key)?.setValue(item[key])

      })

      this.mdl_Edit.get('index')?.setValue(index);


      $("#EditModal").modal('show');

    }

  }

  open_FullEdit() {

    this.mdl_FullEdit.patchValue({

      strSDate: this.mdl_Search.get('strSDate')?.value,

      strEDate: this.mdl_Search.get('strEDate')?.value,

      strUnitID: this.mdl_Search.get('strUnitID')?.value,

      bStartTime: true,

      strStartTime_: '07:00',

      bEndTime: false,

      strEndTime_: '16:00',

    })

    $("#FullEditModal").modal('show');


  }

  openTransfer() {

    if (!this.lstiAttendanceDriver.length) return this._tooltip.showError('لیست انتخابی شما خالی است!')

    this.mdl_Transfer.patchValue({

      strSDate: this.mdl_Search.get('strSDate')?.value,

      strEDate: this.mdl_Search.get('strEDate')?.value,

      strUnitID: this.mdl_Search.get('strUnitID')?.value,

      lstiAttendanceDriver: '',

      bStartTime: false,

      bfKm: false,

      bfkmMission: false,

      bTitripCount: false,

      bEndTime: false,

    })


    $("#TransferModal").modal('show');

  }

  submit_Edit = async () => {

    this.mdl_Edit.patchValue({

      strStartTime_: $("#strStartTime_").val().trim(),

      strEndTime_: $("#strEndTime_").val().trim(),

    })

    if (this.mdl_Edit.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید.');

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_UpdateTemporaryValues`, this._otherService.stringNumberToNumber(this.mdl_Edit.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xzxOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess('با موفقیت ویرایش شد');

            this.list_Result[this.mdl_Edit.get('index')?.value] = res[0];

            $("#EditModal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  submit_FullEdit = async () => {

    this.mdl_FullEdit.patchValue({

      strStartTime_: $("#strStartTime2_").val(),

      strEndTime_: $("#strEndTime2_").val(),

    })

    let model = this.mdl_FullEdit.value;

    if (!model.bStartTime && !model.bEndTime) return this._tooltip.showError('فرم را با دقت تکمیل کنید.');

    if (model.bStartTime && !model.strStartTime_) return this._tooltip.showError('ساعت شروع را وارد کنید.');

    if (model.bEndTime && !model.strEndTime_) return this._tooltip.showError('ساعت پایان را وارد کنید.');

    $.confirm({

      title: `آیا از ویرایش کلی اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_UpdateAllTemporaryValues`, this._otherService.stringNumberToNumber(this.mdl_FullEdit.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xzQxOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess('با موفقیت ویرایش شد');

            this.list_Result = res;

            $("#FullEditModal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });



  }

  removeItem = async (item: any, index: number) => {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iAttendanceDriver: item.iAttendanceDriver

            }

            this._otherService.Showspinner();

            const resp = await axios.post(`AttendanceDriver2_Delete`, model);

            this._otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.iResult != 1) return this._tooltip.showError(res.strError);

            this.list_Result.splice(index, 1)

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.calculateTotals()

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async reCalculate() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید.');

    $.confirm({

      title: `آیا از محاسبه مجدد اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_ReCal2`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xxzOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.list_Result = res;

            this.lst_Search = res;

            this.calculateTotals();

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  async finalApproval() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید.');

    $.confirm({

      title: `آیا از تایید نهایی اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_FinalApproval`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xxzOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.list_Result = res;

            this.lst_Search = res;

            this.calculateTotals();

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  async transfer2PaySlip() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید.');

    $.confirm({

      title: `آیا از انتقال مقادیر به فیش حقوقی اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_Transfer2PaySlip`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xxzOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess("با موفقیت انجام شد");

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  selectAll() {

    if (this.list_Result.length > 0 && (this.list_Result.length != this.lstiAttendanceDriver.length)) {

      this.lstiAttendanceDriver = [];

      this.list_Result.forEach((a: any) => {

        this.lstiAttendanceDriver.push(a.iAttendanceDriver);

      })

      this._tooltip.showSuccess('همه انتخاب شدند')

    }

    else {

      this.lstiAttendanceDriver = [];

    }

  }

  isSelected(item: any): boolean {

    return this.lstiAttendanceDriver.indexOf(item) !== -1;

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstiAttendanceDriver.push(item.iAttendanceDriver);

    else {

      this.lstiAttendanceDriver.find((value: any) => {

        if (value === item.iAttendanceDriver) {

          const index = this.lstiAttendanceDriver.indexOf(item.iAttendanceDriver);

          if (index !== -1) this.lstiAttendanceDriver.splice(index, 1);

        }

      })

    }


  }

  async submit_Transfer() {

    if (!this.lstiAttendanceDriver.length) return this._tooltip.showError('لیست انتخابی شما خالی است!')

    this.mdl_Transfer.patchValue({

      lstiAttendanceDriver: this.lstiAttendanceDriver

    })

    $.confirm({

      title: `آیا از انتقال اطلاعات بهره بردار اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`AttendanceDriver2_TransferTempValues`, this._otherService.stringNumberToNumber(this.mdl_Transfer.value))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: '1xxzOPwZ' } });

              return;

            }

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.list_Result = res;

            this.lst_Search = res;

            await this.calculateTotals();

            this.lstiAttendanceDriver = [];

            $("#TransferModal").modal('hide');

            this._tooltip.showSuccess('با موفقیت انجام شد.')


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }


}
